import { useEffect, useState } from "react";
import { getSocket, type PriceUpdateEvent } from "@/lib/socket";

interface Toast {
  id: string;
  data: PriceUpdateEvent;
}

export default function PriceToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const s = getSocket();

    const handler = (data: PriceUpdateEvent) => {
      const id = Date.now().toString();
      setToasts((prev) => [...prev, { id, data }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 5000);
    };

    s.on("price:update", handler);
    return () => { s.off("price:update", handler); };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="rounded-lg border border-border bg-card p-4 shadow-lg animate-in slide-in-from-right"
        >
          <p className="font-medium text-sm">PR Alert</p>
          <p className="text-xs text-muted-foreground mt-1">
            {toast.data.origin} &rarr; {toast.data.destination}: {toast.data.flightsFound} flights found
            {toast.data.lowestPrice !== null && ` from $${Math.round(toast.data.lowestPrice)}`}
          </p>
        </div>
      ))}
    </div>
  );
}
